// extracted by mini-css-extract-plugin
export default {"mainContent":"style_mainContent__zTKt4","whatsappIcon":"style_whatsappIcon__iRcyg"};